import { useState } from "react";
import { Box, Input } from "@chakra-ui/react";

const DateInput = ({ placeholder, value, onChange, color = "white", w, flex, ...inputProps }) => {
    const [focused, setFocused] = useState(false);
    const showPlaceholder = !focused && !value;
    return (
        <Box position="relative" display="flex" alignItems="center" w={w} flex={flex}>
            <Input
                type="date"
                value={value}
                onChange={onChange}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                color={showPlaceholder ? "transparent" : color}
                w="full"
                {...inputProps}
            />
            {showPlaceholder && (
                <Box
                    position="absolute"
                    left={4}
                    pointerEvents="none"
                    color="text.grey"
                    fontSize="sm"
                    zIndex={1}
                >
                    {placeholder}
                </Box>
            )}
        </Box>
    );
};

export default DateInput;
